import { configureStore, combineReducers } from '@reduxjs/toolkit';
import counterReducer from './Slices/counterSlice';
import layoutReducer from './Slices/layoutSlice';
import loaderReducer from './Slices/loaderSlice';
import themeSlice from './Slices/themeSlice';
import customerSlice from './Slices/customerSlice';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const appReducer = combineReducers({
  loader: loaderReducer,
  counter: counterReducer,
  layout: layoutReducer,
  theme: themeSlice,
  customer: customerSlice

});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_STORE') {
    // This will clear redux-persist and all states
    storage.removeItem('persist:root'); // optional - clear localStorage key
    state = undefined;
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['counter', 'layout', 'theme','customer'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
